const AboutUsDescription = () => {
  return (
    <div className="row">
      <div className="col p-0 w-0 mb-5">
        <div className="card w-100" id="aboutuscard">
          <div className="card-body">
            <p className="card-text ml-5 mr-5">
              Owners Aran and Komen Chen share a passion for cooking. "I grew up
              with my grandmother's love of food," Aran explains. He considers
              himself lucky to have spent so many Sunday afternoons at his
              grandmother's house while she prepared the family's favorite
              recipes. "Every Sunday, my grandmother would cook for the whole
              family. It was a big thing for us growing up. It felt like such a
              gift to learn from such a talented chef." Hoping to share his love
              of food with others, he enrolled at Le Cordon Bleu and studied
              under top chefs in Boston, MA. It was there that he met his future
              wife and co-owner Komen.
              <br />
              <br />
              "Meeting Aran in Boston seemed too good to be true. Here was this
              man who shared my love of food. Not only that, but for family and
              friends." Komen was finishing her Master's Degree in Hospitality
              Studies at Boston University when she met Aran. "Honestly, it just
              seemed like the right thing for me. When Aran proposed opening our
              own restaurant, something in me just went - YES, that's it!"{" "}
              <br />
              <br />
              Looking to move away from the hustle and bustle of the big city,
              Aran and Komen settled in Lunenburg and shortly after opened
              Bangkok Hill in 2005. They've loved sharing their traditional
              culture and foods with their community. <br />
              <br />
              "It's our little dream," explains Komen. "We love making others
              happy."
              <br />
              <br />
              "I hope that anyone who comes here feels like they're home," Aran
              says, "That's what we're striving for everyday."
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUsDescription;
